import {
    fetchItems,
    changeQty,
    deleteItem,
    deleteCart,
} from '~/src/services/cart2';

import { types } from './mutations';

export default {
    // @todo: przepięcie na nowy serwis pozostałych (dodawanie z kafla itp)
    async fetchData({ commit, dispatch }, payload) {
        const { addLoader = true, loaderTarget } = payload || {};
        dispatch('setNeedFetch', false);

        await dispatch('registerRequest', {
            requestHandler: fetchItems,
            successHandler: (data) => {
                const {
                    multisource,
                    itemsCount = 0,
                    totalPrice = 0,
                    items = [],
                    deliveryMethods = [],
                    isPossibleCheckout = false,
                } = data;
                commit(types.SET_TOTAL_PRICE, totalPrice);
                commit(types.SET_IS_POSSIBLE_CHECKOUT, isPossibleCheckout);
                commit(types.SET_DELIVERY_INFO, deliveryMethods);
                commit(types.SET_MULTISOURCE, multisource);
                commit(types.SET_ITEMS, items);
                commit(types.SET_MULTISOURCE, multisource);
                dispatch('setItemsCount', itemsCount);
            },
            errorHandler: (errorMessages) => {
                dispatch('setNeedFetch', true);
                if (this.app && this.app.$logger) {
                    this.app.$logger({
                        message: `Can't fetch cart error: ${errorMessages}`,
                        source: 'store/cart2/actions.js',
                    });
                }
            },
            addLoader,
            loaderTarget,
        }, { root: true });
    },
    changeQty({ dispatch, commit }, payload) {
        const { addLoader = true, loaderTarget, id, qty, withFetch = true } = payload || {};

        dispatch('registerRequest', {
            requestHandler: changeQty.bind(this, { id, qty }),
            successHandler: () => {
                commit(types.SET_ITEM_QTY, { id, qty });
                if (withFetch) {
                    dispatch('fetchData', payload);
                }
            },
            onError: (errorMessages) => {
                dispatch('setNeedFetch', true);
                if (this.app && this.app.$logger) {
                    this.app.$logger({
                        message: `Can't changeQty cart error: ${errorMessages}`,
                        source: 'store/cart2/actions.js',
                    });
                }
            },
            addLoader,
            loaderTarget,
        }, { root: true });
    },
    deleteItem({ dispatch, commit }, payload) {
        const { addLoader = true, loaderTarget, id, withFetch = true } = payload || {};

        dispatch('registerRequest', {
            requestHandler: deleteItem.bind(this, { id }),
            successHandler: () => {
                commit(types.DELETE_ITEM, { id });
                if (withFetch) {
                    dispatch('fetchData', payload);
                }
            },
            errorHandler: (errorMessages) => {
                dispatch('setNeedFetch', true);
                if (this.app && this.app.$logger) {
                    this.app.$logger({
                        message: `Can't deleteItem cart error: ${errorMessages}`,
                        source: 'store/cart2/actions.js',
                    });
                }
            },
            addLoader,
            loaderTarget,
        }, { root: true });
    },
    setItemsCount({ commit, state }, count) {
        if (count || count === 0) {
            commit(types.SET_ITEMS_COUNT, count);
        } else {
            commit(types.SET_ITEMS_COUNT, state.items.length); // @todo: potwierdzić sposób liczenia z Rafałem.
        }
    },
    setNeedFetch({ commit }, needFetch) {
        commit(types.SET_NEED_FETCH, needFetch);
    },
    flushCart({ commit, dispatch }, payload) {
        const { addLoader = true, loaderTarget } = payload || {};
        dispatch('registerRequest', {
            requestHandler: deleteCart,
            successHandler: () => {
                commit(types.FLUSH_CART);
                dispatch('setNeedFetch', false);
            },
            errorHandler: (errorMessages) => {
                dispatch('setNeedFetch', true);
                if (this.app && this.app.$logger) {
                    this.app.$logger({
                        message: `Can't flush cart error: ${errorMessages}`,
                        source: 'store/cart2/actions.js',
                    });
                }
            },
            addLoader,
            loaderTarget,
        }, { root: true });
    },
    softFlushCart({ commit, dispatch }) {
        commit(types.FLUSH_CART);
        dispatch('setNeedFetch', true);
    },
    fetchDataIfNeed({ state, dispatch }, payload) {
        if (state.needFetch) {
            return dispatch('fetchData', payload);
        }
    },
};
